<script setup>
import { computed } from 'vue'
import { Badge } from '@drama/ui'

import AuditCard from './AuditCard.vue'
import { useAuditText } from './audit-text.js'
import { currentScene, recordingState } from './run-observer.js'

const props = defineProps({
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
})

const { tr, storyTimeLabel } = useAuditText()
const scene = computed(() => currentScene(props.pack, props.branch))
// 后台剧情记录待办或失败时，提示行说明正文已保存、场景与见闻还在更新或需要重试。
const recording = computed(() => recordingState(props.branch))
</script>

<template>
  <AuditCard :title="tr('scene.title')" :hint="recording ? tr(`scene.recording.${recording}`) : ''" data-testid="scene-card">
    <template v-if="scene.location">
      <div class="au-scene">
        <div class="au-scene__text">
          <h3 class="au-scene__name">{{ scene.location.name }}</h3>
          <p v-if="scene.location.description" class="au-body">{{ scene.location.description }}</p>
        </div>
        <img v-if="scene.location.image" class="au-scene__image" :src="scene.location.image" :alt="scene.location.name" />
      </div>
      <dl class="au-kv">
        <dt>{{ tr('scene.people') }}</dt>
        <dd class="au-chips">
          <Badge v-for="person in scene.people" :key="person.id" size="sm">{{ person.name }}</Badge>
          <span v-if="!scene.people.length" class="au-muted">{{ tr('empty') }}</span>
        </dd>
        <dt>{{ tr('scene.storyTime') }}</dt>
        <dd>{{ storyTimeLabel(scene.time) }}</dd>
        <dt>{{ tr('scene.items') }}</dt>
        <dd>{{ scene.items.length }}</dd>
      </dl>
    </template>
    <p v-else class="au-empty">{{ tr('empty') }}</p>
  </AuditCard>
</template>
